import { render, staticRenderFns } from "./createBatchProducts.vue?vue&type=template&id=a7a7917c&scoped=true"
import script from "./createBatchProducts.vue?vue&type=script&lang=js"
export * from "./createBatchProducts.vue?vue&type=script&lang=js"
import style0 from "./createBatchProducts.vue?vue&type=style&index=0&id=a7a7917c&prod&lang=scss"
import style1 from "./createBatchProducts.vue?vue&type=style&index=1&id=a7a7917c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a7917c",
  null
  
)

export default component.exports